import { actionTypes } from 'redux-form';

export const LOAD_SCHEMA_START = 'LOAD_SCHEMA_START';
export const LOAD_SCHEMA_SUCCESS = 'LOAD_SCHEMA_SUCCESS';
export const LOAD_SCHEMA_ERROR = 'LOAD_SCHEMA_ERROR';
export const SUBMIT_APPLICATION_START = 'SUBMIT_APPLICATION_START';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export const SUBMIT_APPLICATION_ERROR = 'SUBMIT_APPLICATION_ERROR';
export const CONTINUE_TO_FORM = 'CONTINUE_TO_FORM';
export const VALIDATE_FORM_GROUP_SUCCESS = 'VALIDATE_FORM_GROUP_SUCCESS';

export interface ContinueToForm {
  type: typeof CONTINUE_TO_FORM;
}

export interface LoadSchemaStart {
  type: typeof LOAD_SCHEMA_START;
}

export interface LoadSchemaSuccess {
  type: typeof LOAD_SCHEMA_SUCCESS;
  schema: any;
  formIds: FormIds;
  asyncGroups: AsyncGroup[];
}

export interface LoadSchemaError {
  type: typeof LOAD_SCHEMA_ERROR;
  errorMsg: string;
}

export interface SubmitApplicationStart {
  type: typeof SUBMIT_APPLICATION_START;
}

export interface SubmitApplicationSucccess {
  type: typeof SUBMIT_APPLICATION_SUCCESS;
  confirmationNumber?: number;
}

export interface SubmitApplicationError {
  type: typeof SUBMIT_APPLICATION_ERROR;
  error: string;
}

export interface ValidateFormGroupSuccess {
  type: typeof VALIDATE_FORM_GROUP_SUCCESS;
  fields: string[];
}

export interface StartAsyncValidation {
  type: typeof actionTypes.START_ASYNC_VALIDATION;
  meta: {
    field: string;
    form: string;
  };
}

export type WizardActionTypes =
  | ContinueToForm
  | LoadSchemaStart
  | LoadSchemaSuccess
  | LoadSchemaError
  | SubmitApplicationStart
  | SubmitApplicationSucccess
  | SubmitApplicationError;

export interface WizardState {
  continueWithForm: boolean;
  loading: boolean;
  fetchError?: string;
  schema?: FormSchema;
  formIds?: FormIds;
  data?: FormValues;
  submittingApplication: boolean;
  applicationSubmitError?: string;
  submitted: boolean;
  confirmationNumber?: number;
  asyncGroups?: AsyncGroup[];
}
